import React, { useRef, useEffect } from "react";
import { ElementRoot } from "./ElementRoot.jsx";
import { mediaElementShape } from "./shapes/index.jsx";

export const VideoPreview = ({ url }) => {
  const ref = useRef(null);

  useEffect(() => {
    ref.current.load();
  }, [url]);

  return (
    <ElementRoot loaded>
      <video
        ref={ref}
        autoPlay
        controls
        data-testid="video-preview"
      >
        <source src={url} />
      </video>
    </ElementRoot>
  );
};

VideoPreview.propTypes = mediaElementShape;
